import * as Icon from 'react-bootstrap-icons';
import Artikelzeile from "./Artikelzeile";
import SimpleModal from "../Modal/SimpleModal";
import React, {useEffect, useState} from "react";
import axios, {formToJSON} from "axios";
import {APIBASE} from "../../config/Pfalzmarkt.config";
import TextSimpleInput from "../../FormElements/TextSimpleInput";
import {useStore} from "../../store/store";
import ArtikelVorlage from "./ArtikelVorlage";
import {jwtDecode} from "jwt-decode";
import './Streckengeschaeft.css';

export default function Streckengeschaeft() {
    const [globalState, dispatch] = useStore();
    const header = "Authorization: Bearer " + localStorage.getItem("token");
    const [userNameInToken, setUserNameInToken] = useState('');
    const [state, setState] = useState({rows: []});
    const [isSend, setIsSend] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [lastCustomer, setLastCustomer] = useState([]);
    const [kundenName, setkundenName] = useState(null);
    const [kopieAnErzeugerChecked, setKopieAnErzeugerChecked] = useState(false);
    const [positions, setPositions] = useState([]);
    const errorMessages = {
        kundenname: "Bitte geben Sie den Namen des Endkunden an.",
        bestellnummer: "Bitte geben Sie die Kundenbestellnummer an.",
        lsnr: "Bitte geben Sie die Lieferscheinnummer an.",
        date: "Bitte geben Sie ein Datum ein."

    }

    const handleRemoveSpecificRow = (idx) => {
        document.getElementById(idx).remove();
    }

    const handleAddRow = () => {
        const item = {
            artikel: "",
            artikelSorte: "",
            artikelBemerkung: "",
            artikelZusatz: "",
            leergut: "",
            verpackung: "",
            kolliMenge: "",
            Paltettenmenge: "",
            Palettentyp: "",
        };
        setState({
            rows: [...state.rows, item]
        });

    };

    const deleteAllRows = () => {
        if (window.confirm('Möchten Sie wirklich alle Zeilen löschen?')) {
            const tbody = document.getElementById('streckengeschaeftRows');
            while (tbody.firstChild) {
                tbody.firstChild.remove();
            }
        }
    }

    const loadTemplate = async (customerName) => {
        if ("" === customerName) {
            setkundenName(() => null);
            return;
        }
        console.log(customerName);
        setkundenName(() => customerName);
        try {
            axios.get(
                APIBASE + 'api/streckengeschaeft/getLastPositions/' + customerName, {headers: header}
            ).then((response) => {
                    const loadedPostions = [];
                    let i = 0;
                    for (const position of response.data) {
                        position.id = i;
                        i++;
                        loadedPostions.push(position);
                    }
                    setPositions(loadedPostions);
                }
            );
        } catch (err) {
            if (401 === err.response.status) {
                dispatch('IS_401_ERROR', true);
                dispatch('SET_AUTHTOKEN', null);
            }
            console.log(err.message); // Todo: Errorhandling

        }


        try {
            axios.get(
                APIBASE + 'api/streckengeschaeft/getLastInfo/' + customerName, {headers: header}
            ).then((response) => {
                    setKopieAnErzeugerChecked(response.data.kopieAnErzeuger);
                }
            );
        } catch (err) {
            if (401 === err.response.status) {
                dispatch('IS_401_ERROR', true);
                dispatch('SET_AUTHTOKEN', null);
            }
            console.log(err.message); // Todo: Errorhandling

        }
        if (document.getElementById('n0')) {
            document.getElementById('n0').remove();
        }

    }

    useEffect(() => {
        if (globalState.token) {
            setUserNameInToken(jwtDecode(localStorage.getItem("token")).username);
            fetchLastCustomer();
            handleAddRow();
        }


    }, [globalState.token]);

    function sendForm(event) {
        event.preventDefault();
        event.target.checkValidity();
        let formData = formToJSON(event.target);
        formData.template = 'streckenhgeschaeft';
        axios({
            method: 'post',
            url: APIBASE + 'api/streckengeschaeft/save',
            rejectUnauthorized: false,
            data: formData,
            headers: header
        }).then(result => {
            console.log('streckengeschaeft saved');
            setIsSend(true);
            setShowModal(true);
        })
            .catch(error => {
                if (401 === error.response.status) {
                    dispatch('IS_401_ERROR', true);
                    dispatch('SET_AUTHTOKEN', null);
                }
                console.log(error);
            });


    }

    const deleteTemplate = async (customerName) => {
        try {
            const response = await axios.get(
                APIBASE + 'api/streckengeschaeft/deleteTemplate/' + document.getElementById('aktuelleKunden').value, {headers: header}
            );
            await response.data;

        } catch (err) {
            if (401 === err.response.status) {
                dispatch('IS_401_ERROR', true);
                dispatch('SET_AUTHTOKEN', null);
            }
            console.log(err.message); // Todo: Errorhandling

        }
    }


    const fetchLastCustomer = async () => {
        try {
            const response = await axios.get(
                APIBASE + 'api/streckengeschaeft/getLastCustomers', {headers: header}
            );
            const data = await response.data;
            setLastCustomer(data);
        } catch (err) {
            if (401 === err.response.status) {
                dispatch('IS_401_ERROR', true);
                dispatch('SET_AUTHTOKEN', null);
            }
            console.log(err.message); // Todo: Errorhandling

        }
    };
    return (
        <div className="container-fluid">
            <SimpleModal show={showModal} onHide={() => setShowModal(false)} content={{
                title: 'Streckengeschäft gespeichert',
                body: 'Das Streckengeschäft wurde gespeichert'
            }}/>
            <form id="streckengeschaeft" onSubmit={sendForm}>
                <h1>Streckengeschäft</h1>
                <table className="table-responsive">
                    <tbody>
                    <tr>
                        <td><b>Erzeugernummer &nbsp;</b></td>
                        <td>
                            <input type="text" className="form-control" name="erzeuger" id="erzeuger"
                                   defaultValue={userNameInToken && userNameInToken} readOnly="readonly"/>
                        </td>
                        <td rowSpan="6"><p>Wenn Sie ein Streckengeschäft als Vorlage speichern möchten, aktivieren Sie
                            bitte die Checkbox „Als Vorlage speichern“. Dann werden die eingegeben Positionen
                            übernommen, und können für folgende Meldungen genutzt werden.<br/>
                            Einzelne Zeilen können durch Klick auf das Minus-Zeichen am Ende der jeweiligen Zeile
                            gelöscht werden. Möchten Sie alle Zeilen löschen, klicken Sie auf den Button „Alle Zeilen
                            löschen“. Nach nochmaliger Bestätigung werden dann alle bisherigen Positionen gelöscht.
                            Zeilen hinzufügen können Sie über den Klick auf das Plus-Zeichen unterhalb der letzten
                            Zeile.<br/>
                            Wenn Sie die Checkbox „Testversand“ aktivieren, erfolgt kein Versand der Meldung an die
                            Pfalzmarkt, im Normalfall benötigen Sie diese Funktion nicht.</p></td>
                    </tr>
                    <tr>
                        <td><b>E-Mail Kopie</b>&nbsp;</td>
                        <td>
                            <input className="form-check-input" type="checkbox" name="kopieAnErzeuger" value="1"
                                   defaultChecked={kopieAnErzeugerChecked}/>
                        </td>
                    </tr>
                    <tr>
                        <td><b>Kundenname </b></td>
                        <td key="foo">
                            <select id="aktuelleKunden" name="aktuelleKunden" onChange={(event) => {
                                loadTemplate(event.target.value);
                            }}>
                                <option value="">Bitte auswählen</option>
                                {lastCustomer.map((customer) => {
                                    <option value={customer}>{customer}</option>
                                })}{lastCustomer.map((customer) => {
                                return <option value={customer}>{customer}</option>
                            })}
                            </select>
                            {document.getElementById('aktuelleKunden') && document.getElementById('aktuelleKunden').value !== '' &&
                                <button className="btn btn-secondary btn-sm" onClick={deleteTemplate}> Vorlage
                                    löschen</button>}
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <TextSimpleInput name="kundenname" placeholder="Kundenname" required={true}
                                             value={kundenName && kundenName}
                                             invalidMessage={errorMessages.kundenname}/>
                        </td>
                    </tr>
                    <tr>
                        <td><b>Bestellnummer&nbsp;</b></td>
                        <td>
                            <TextSimpleInput name="bestellnummer" placeholder="Kundenbestellnummer" required={false}
                                             invalidMessage={errorMessages.bestellnummer}/>
                        </td>
                    </tr>
                    <tr>
                        <td><b>LS-Nr.</b></td>
                        <td>
                            <TextSimpleInput type="text" className="form-control" name="lsnr"
                                             placeholder="Nummer aus dem Lieferscheinbuch"/>

                        </td>
                    </tr>
                    <tr>
                        <td><b>Datum</b></td>
                        <td>
                            <TextSimpleInput type="date" className="form-control" name="date" required={true}
                                             invalidMessage={errorMessages.date}/>
                        </td>
                    </tr>
                    <tr>
                        <td><b>Als Vorlage speichern</b></td>
                        <td>
                            <input className="form-check-input" type="checkbox" name="vorlageSpeichern" value="1"/>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="3">
                            <b>Bei gewählter Preisart "Kundenpreisliste" kann auf die Eingabe im Feld "Preis pro
                                Preiseinheit" verzichtet werden.</b>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <button type="submit" className="btn btn-secondary btn-sm" disabled={isSend}>Senden
                            </button>
                        </td>
                        <td>
                            <input type="checkbox" className="form-check-input" name="testversand" value="1"/>Testversand
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table className="table-responsive">
                    <thead>
                    <tr>
                        <th>Artikel</th>
                        <th>Sorte</th>
                        <th>Zusatz</th>
                        <th>Bemerkung</th>
                        <th>Leergut</th>
                        <th>Inhalt</th>
                        <th>Kolli Menge</th>
                        <th>Palettenmenge</th>
                        <th>Palettentyp</th>
                        <th>Kolli pro<br/>Palette</th>
                        <th>Preis pro<br/> Preiseinheit</th>
                        <th>Preiseinheit<br/> kg/stk</th>
                        <th>Preisart</th>
                        <th>Zeile löschen</th>
                    </tr>
                    </thead>
                    <tbody id="streckengeschaeftRows">
                    {state.rows.map((item, idx) => (
                        <Artikelzeile key={'n' + idx} handler={handleRemoveSpecificRow} idx={'n' + idx}/>
                    ))}
                    <ArtikelVorlage positions={positions}/>
                    </tbody>
                </table>
                <div className="row">
                    <div className="col-4">
                        <button type="button" onClick={handleAddRow} className="btn btn-secondary btn-sm">
                            <Icon.PlusCircle/>
                        </button>
                        <button type="button" onClick={deleteAllRows} className="btn btn-secondary btn-sm">
                            Alle Zeilen löschen
                        </button>
                    </div>

                </div>
            </form>
        </div>
    )
        ;
}